import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class MwRadio extends Component {
  @tracked periodRadioS = 'option-1';
  @tracked periodRadioM = 'option-1';
  @tracked periodRadioL = 'option-1';

  @action
  requireReplyChange(value) {
    this.periodRadioS = value;
  }

  @action
  requireReplyChangeM(value) {
    this.periodRadioM = value;
  }

  @action
  requireReplyChangeL(value) {
    this.periodRadioL = value;
  }
}
